import { motion } from "framer-motion";
import { STAY_TOUR, IMAGES } from "@/data/content";
import { SectionHead } from "@/components/landing/Categories";
import * as Icons from "lucide-react";

export const StayTour = () => (
  <section id="stay-tour" className="relative py-24 px-5 sm:px-8 bg-[#09090B]">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative order-2 lg:order-1"
      >
        <div className="rounded-3xl overflow-hidden gold-border">
          <img
            src={IMAGES.venue_chancery}
            alt="Stay and tour"
            className="w-full h-[520px] object-cover"
          />
        </div>
        <div className="absolute -top-6 -right-6 bg-[#09090B] gold-border rounded-2xl px-6 py-4 gold-glow">
          <div className="font-serif-lux text-xl text-amber-100">Nandi Hills</div>
          <div className="text-xs text-zinc-400">or Isha Foundation</div>
        </div>
      </motion.div>

      <div className="order-1 lg:order-2">
        <SectionHead
          eyebrow="Optional Experience · JFC Awardees"
          title="Stay & Tour Package"
          sub="Extend your celebration with a curated one-day stay at Earth Trials by Campee and tour experience around Bangalore — approx $50 per person."
        />
        <div className="grid sm:grid-cols-2 gap-4">
          {STAY_TOUR.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Check;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="flex items-center gap-3 p-4 rounded-xl bg-[#18181F] gold-border"
                data-testid={`stay-tour-${i}`}
              >
                <Icon className="w-5 h-5 text-amber-400 shrink-0" strokeWidth={1.8} />
                <span className="text-zinc-200 text-sm">{s.title}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
